import AOS from 'aos'
import 'aos/dist/aos.css'

const addAosToClasses = (classesConfig) => {
    for (const [className, animation] of Object.entries(classesConfig)) {
        document.querySelectorAll(className).forEach((element) => {
            element.setAttribute('data-aos', animation)
        })
    }
}

export const initAos = () => {
    addAosToClasses({
        '.fade-up': 'fade-up',
        '.fade': 'fade',
        '.c-hero': 'fade-up',
        '.c-hero-home': 'fade-up',
        '.block-wrapper': 'fade-up',
        '.c-interested-in': 'fade-up',
        '.c-newsletter-wrapper': 'fade-up',
        '.prose': 'fade',
        '.c-card': 'fade',
    })

    AOS.init({
        offset: 100,
        duration: 400,
        easing: 'ease-in-out',
        once: false,
    })
}
